import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ActionListArchivedService } from '../dashboard/action-list-archived/action-list-archived.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';

@Component({
  selector: 'app-actionlist-trash',
  templateUrl: './actionlist-trash.component.html',
  styleUrls: ['./actionlist-trash.component.scss']
})
export class ActionlistTrashComponent implements OnInit {
  trashActionLists: any = [];
  displayedColumns = ['name', 'star'];
  displayNoRecords: boolean = false;
  bgTextColor = "#000000";

  constructor(
    private _actionListService: ActionListArchivedService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _sharedService: SharedService,
    private _dashboardService: DashboardService
  ) { 
	this._sharedService.searchChange.subscribe(value => {
		this.trashActionLists.filter = value.toLowerCase();
		if (this.trashActionLists.filteredData.length === 0) {
			this.displayNoRecords = true;
		} else {
			this.displayNoRecords = false;
		}
	});
  }

  	ngOnInit() {
    	this.onInit();
  	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	onInit(): void {
		let searchInput = document.getElementById("searchInput");
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
			searchInput["value"] = "";
			this.displayNoRecords = false;
			this.trashActionLists = [];
			this._actionListService.getDeletedActionLists(localStorage.getItem('organization')).subscribe((response) => {
		if (response["success"]) {
			if (response["data"] && response["data"].length > 0) {
				this.trashActionLists = new MatTableDataSource(response["data"]);
			}
		}
		}, (error) => {
			console.log(error);
			this.openSnackBar("Server side error occurred");
		})
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}

	archiveActionTypeForms(_id) {
		this._sharedService.confirmationDialog("Are you sure you want to archive the List and forms in it?", ()=>{
			let requestData = {
				actionTypeId: _id
			};
			this._dashboardService.archiveActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this._router.navigateByUrl('/dashboard');
					this.openSnackBar(response["message"]);
					this.onInit();
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	deleteActionTypeForms(_id) {
		this._sharedService.confirmationDialog("Are you sure you want to delete the List and forms in it?", ()=>{
			let requestData = {
				actionTypeId: _id
			};
			this._dashboardService.deleteActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(response["message"]);
					// this.onInit();
					this._router.navigateByUrl('/dashboard');
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	restoreDeletedActionList(id) {
		this._sharedService.confirmationDialog("Are you sure you want to restore the List", () => {
			let requestData = {
				actionTypeId: id
			};
	
			this._sharedService.restoreDeletedActionList(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(response["message"]);
					this._dashboardService.refreshCount([]);
					this.onInit();
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	onReloadClick(): void {
		this.onInit();
	}
}
